module.exports = __webpack_public_path__ + "img/placeholder.be5030ca.webp";